import lodash from "lodash";
import {
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect,
    createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/hazDistributor";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const callDistributor = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "isCeo", type: "Boolean", operator: "=", value: true }
    ];
    if (searchQuery) {
        where.push({ openBucket: true, name: "companyNameTh", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", closeBucket: true, name: "fullNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "companyNameTh", "companyNameEn", "idCard", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "companyNameTh", type: "ASC" }],
                children: [
                    {
                        name: "addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "2" }]
                    }
                ]
            }
        })
        .then(page => page.data);
};

export const createField = ({ props, data, key /* , isLoading */ }) => {
    const { viewOnly /* , menuContext */ } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDistributor`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDistributor.refDistributor"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDistributor,
                            "onUpdate:value": value => (model.refDistributor = value),
                            disabled: viewOnly,
                            list: callDistributor,
                            renderLabel: ({ item }) => {
                                if (item.refPersonType?.key === "1") {
                                    return <div>{item.companyNameTh}</div>;
                                }
                                return <div>{item.fullNameTh}</div>;
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: {
                    getValue: ({ record, field }) =>
                        lodash.get(record, `${field.key}.${record.refPersonType?.key === "1" ? "companyNameTh" : "fullNameTh"}`)
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDistributor.idCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => (["1"].includes(model.refDistributor?.refPersonType?.key) ? i18n.global.t("views.register.idTax") : i18n.global.t("model.user.idCard")),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDistributor?.idCard,
                            disabled: true,
                            comma: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDistributor.addresses.0.addrTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("views.request.hazDistributor.addressContact"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDistributor?.addresses?.[0]?.addrTh,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDistributor.addresses.0.location`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.hazDistributor.location"),
                inputProp: ({ field }) => {
                    let utm = null;
                    const utmObj = require("utm-latlng");
                    const utmLatlng = new utmObj();
                    const lat = parseFloat(model.refDistributor?.addresses?.[0]?.latitude);
                    const lng = parseFloat(model.refDistributor?.addresses?.[0]?.longitude);
                    if (!isNaN(lat) && !isNaN(lng)) {
                        utm = utmLatlng.convertLatLngToUtm(lat, lng, 8);
                    }
                    return lodash.merge(
                        {
                            value: utm ? `${utm.ZoneNumber}${utm.ZoneLetter} ${utm.Easting.toFixed(2)} ${utm.Northing.toFixed(2)}` : "",
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDistributor.addresses.0.tel`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.tel"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDistributor?.addresses?.[0]?.tel,
                            disabled: true,
                            comma: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDistributor.email`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.email"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDistributor?.email,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDistributor.addresses.0.fax`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.address.fax"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDistributor?.addresses?.[0]?.fax,
                            disabled: true,
                            comma: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;

    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
